import { Component } from '@angular/core';
import { FollowButton, HomeCard, HomeCardComponentType, HomeCardIcon, HomeCardLink } from '@tytapp/app/pages/home-page/home-cards.service';

@Component({
    templateUrl: './home-support-c2a.component.html',
    styleUrls: ['./home-support-c2a.component.scss']
})
export class HomeSupportC2AComponent implements HomeCardComponentType {
    card: HomeCard;
    fullBleed = true;
}